module.exports = __webpack_public_path__ + "img/logo-rossignol.b7455ce6.svg";